export default {title:'Analysis of Alternatives and Risk'};